'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _undoRedoTransactionManager = require('./undoRedoTransactionManager');

var _undoRedoTransactionsReducer = require('./undoRedoTransactionsReducer');

var _undoRedoTransactionsReducer2 = _interopRequireDefault(_undoRedoTransactionsReducer);

var _undoRedoConstants = require('./undoRedoConstants');

var _authConstants = require('../../auth/authConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Utils
var initialState = Immutable.Map({
    operation: null,
    mostRecentTransactionId: (0, _undoRedoTransactionManager.getCurrentTransactionId)(),
    transactions: Immutable.Map(),
    undoStack: Immutable.Stack(),
    redoStack: Immutable.Stack()
});

// General Stack


// Reducers
// Lib
var getNextFromStack = function getNextFromStack(stackName) {
    return function (state) {
        return state.get(stackName).peek();
    };
};
var removeNextFromStack = function removeNextFromStack(stackName) {
    return function (state) {
        return state.update(stackName, function (stack) {
            return stack.shift();
        });
    };
};

// UNDO STACK
var addToStackWithLimit = function addToStackWithLimit(value) {
    return function (stack) {
        return stack.size < _undoRedoConstants.UNDO_STACK_LIMIT ? stack.unshift(value) : stack.slice(0, _undoRedoConstants.UNDO_STACK_SLICE_SIZE).unshift(value);
    };
};

var addToUndoStack = function addToUndoStack(state, undoActionId) {
    return state.update('undoStack', addToStackWithLimit(undoActionId));
};
var getNextUndo = getNextFromStack('undoStack');
var removeNextUndo = removeNextFromStack('undoStack');

// REDO STACK
// No limit on the redo stack
var addToRedoStack = function addToRedoStack(state, redoActionId) {
    return state.update('redoStack', function (redoStack) {
        return redoStack.unshift(redoActionId);
    });
};

var clearRedoStack = function clearRedoStack(state, action) {
    return state.update('redoStack', function (redoStack) {
        return redoStack.clear();
    });
};
var getNextRedo = getNextFromStack('redoStack');
var removeNextRedo = removeNextFromStack('redoStack');

// STATE REDUCER

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (action.type === _authConstants.LOGOUT) {
        return initialState;
    }

    var updatedState = state;
    if (action.type === _undoRedoConstants.START_OPERATION) {
        updatedState = updatedState.set('operation', action.name);
    }
    if (action.type === _undoRedoConstants.END_OPERATION) {
        updatedState = updatedState.set('operation', null);
    }

    if (action.remote || !action.transactionId) return updatedState;

    var mostRecentTransactionId = updatedState.get('mostRecentTransactionId');
    var isNewTransaction = action.transactionId > mostRecentTransactionId;

    // Add the action to the transactions map if required
    updatedState = updatedState.update('transactions', function (transactionsState) {
        return (0, _undoRedoTransactionsReducer2.default)(transactionsState, action);
    });

    if (isNewTransaction) {
        updatedState = updatedState.set('mostRecentTransactionId', action.transactionId);

        // Remove the transactions in the redo stack from the transactions map (as they can never be undone or redone
        // from this point onwards).
        var transactionIds = updatedState.get('redoStack');
        updatedState = updatedState.update('transactions', function (transactionsState) {
            return (0, _undoRedoTransactionsReducer.clearTransactions)(transactionsState, transactionIds);
        });

        // Add to undo stack
        updatedState = addToUndoStack(updatedState, action.transactionId);

        // clear redo stack
        updatedState = clearRedoStack(updatedState);
    }

    if (action.isUndo) {
        // The action to add to the redo stack now that it has been 'undone'
        var redoTransactionId = getNextUndo(updatedState);

        // Only change the stack if the action being undone is the first of the undo stack (subsequent actions will not
        // modify the stacks).
        if (action.transactionId === redoTransactionId) {
            updatedState = removeNextUndo(updatedState);
            updatedState = addToRedoStack(updatedState, redoTransactionId);
        }
    }

    if (action.isRedo) {
        // The action to add to the undo stack now that it has been 'redone'
        var undoTransactionId = getNextRedo(updatedState);

        // Only change the stack if the action being redone is the first of the redo stack (subsequent actions will not
        // modify the stacks).
        if (action.transactionId === undoTransactionId) {
            updatedState = removeNextRedo(updatedState);
            updatedState = addToUndoStack(updatedState, undoTransactionId);
        }
    }

    return updatedState;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/undoRedo/undoRedoReducer.js
// module id = 2148
// module chunks = 0